import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { State } from 'store/types';
import { FETCH_PRODUCTS } from 'modules/products';
import { SpaceoKubRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

registerWidget<State, Record<string, string>>(`${__NAME__}/spaceo-kub`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);
  store.dispatch(FETCH_PRODUCTS.success, state.products?.productList ?? undefined);

  return remoteProps => <SpaceoKubRemote router={router} store={store} {...remoteProps} />;
});
